import type { QuoteKeys, QuoteKeysPrefix } from 'locales/quoteKeys';
import type { FormRecord } from 'models/formError';

import { connectValidationErrors } from './ValidationErrors.connect';
import { ValidationErrorComponent } from './ValidationErrors.status';

export const ValidationErrors = connectValidationErrors(
  ValidationErrorComponent<FormRecord, QuoteKeys, QuoteKeysPrefix>,
);
